import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Dropdown } from '@whitbread-eos/atoms';
import { useSemanticTypography } from '@whitbread-eos/utils';
import { SORT_TYPES, NEW_PI_SORT_TYPES, NEW_BB_SORT_TYPES } from './constants';
import { jsx as _jsx } from "react/jsx-runtime";
export default function SortBy(_ref) {
  var labels = _ref.labels,
    selectedOption = _ref.selectedOption,
    _ref$isDisabled = _ref.isDisabled,
    isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled,
    onChange = _ref.onChange,
    _ref$isPiSortOrderDro = _ref.isPiSortOrderDropdownEnabled,
    isPiSortOrderDropdownEnabled = _ref$isPiSortOrderDro === void 0 ? false : _ref$isPiSortOrderDro,
    _ref$isBbSortOrderDro = _ref.isBbSortOrderDropdownEnabled,
    isBbSortOrderDropdownEnabled = _ref$isBbSortOrderDro === void 0 ? false : _ref$isBbSortOrderDro,
    buttonProps = _ref.buttonProps,
    _ref$isSplitView = _ref.isSplitView,
    isSplitView = _ref$isSplitView === void 0 ? false : _ref$isSplitView;
  var getTypographyProps = useSemanticTypography();
  var labelTypographyStyles = getTypographyProps(sortByLabelLegacyTypography, sortByLabelSemanticTypography);
  var menuButtonTypographyStyles = getTypographyProps(sortByMenuButtonLegacyTypography, sortByMenuButtonSemanticTypography);
  var menuItemTypographyStyles = getTypographyProps(sortByMenuItemLegacyTypography, sortByMenuItemSemanticTypography);
  var wrapperStyles = isSplitView ? _objectSpread(_objectSpread({}, dropdownWrapperStyles), {}, {
    marginRight: 0
  }) : dropdownWrapperStyles;
  var dropdownStyles = {
    wrapperStyles,
    menuButtonStyles: _objectSpread(_objectSpread({}, dropdownMenuStyles), menuButtonTypographyStyles),
    menuButtonTextStyles: menuButtonTypographyStyles,
    menuItemStyles: menuItemTypographyStyles
  };
  if (buttonProps) {
    dropdownStyles = {
      wrapperStyles,
      menuButtonStyles: _objectSpread(_objectSpread(_objectSpread({}, dropdownMenuStyles), menuButtonTypographyStyles), buttonProps),
      menuButtonTextStyles: menuButtonTypographyStyles,
      menuItemStyles: menuItemTypographyStyles
    };
  }
  var sortByOptions = getSortByOptions(labels, isPiSortOrderDropdownEnabled, isBbSortOrderDropdownEnabled);
  return _jsx(Dropdown, {
    options: sortByOptions,
    matchWidth: true,
    dropdownStyles: _objectSpread(_objectSpread({}, dropdownStyles), {}, {
      labelTextStyles: labelTypographyStyles,
      menuItemTextStyles: menuItemTypographyStyles
    }),
    selectedId: selectedOption,
    onChange: onChange,
    dataTestId: "sort-by",
    disabled: isDisabled
  });
}
var dropdownWrapperStyles = {
  w: {
    base: '8.125rem',
    xs: '10.25rem',
    sm: '12.125rem',
    lg: '11.5rem'
  },
  marginRight: {
    mobile: '0',
    xs: 'lg'
  },
  zIndex: '9'
};
var dropdownMenuStyles = {
  w: 'full',
  h: 'var(--chakra-space-2xl)',
  borderRadius: '0.1875rem',
  borderColor: 'lightGrey2',
  _hover: {
    borderColor: 'primary'
  },
  _focus: {
    borderColor: 'lightGrey2'
  }
};
var sortByLabelLegacyTypography = {
  fontSize: 'var(--chakra-fontSizes-sm)',
  lineHeight: 'var(--chakra-lineHeights-1)'
};
var sortByLabelSemanticTypography = {
  textStyle: 'body-m-regular'
};
var sortByMenuButtonLegacyTypography = {
  fontSize: 'var(--chakra-fontSizes-md)',
  lineHeight: 'var(--chakra-lineHeights-3)'
};
var sortByMenuButtonSemanticTypography = {
  textStyle: 'body-m-regular'
};
var sortByMenuItemLegacyTypography = {
  fontSize: 'var(--chakra-fontSizes-sm)',
  lineHeight: 'var(--chakra-lineHeights-1)'
};
var sortByMenuItemSemanticTypography = {
  textStyle: 'body-s-regular'
};
function getSortByOptions(labels, isPiSortOrderDropdownEnabled, isBbSortOrderDropdownEnabled) {
  var getOptions = (sortTypes, order) => order.map((key, index) => ({
    id: sortTypes[index + 1],
    label: labels[key]
  }));
  if (isPiSortOrderDropdownEnabled) {
    return getOptions(NEW_PI_SORT_TYPES, ['sortByRecommended', 'sortByDistance', 'sortByPrice']);
  }
  if (isBbSortOrderDropdownEnabled) {
    return getOptions(NEW_BB_SORT_TYPES, ['sortByDistance', 'sortByRecommended', 'sortByPrice']);
  }
  return getOptions(SORT_TYPES, ['sortByDistance', 'sortByPrice']);
}